import React from 'react';
import { Package, Loader2 } from 'lucide-react';

interface LoadingSpinnerProps {
  message?: string;
  variant?: 'default' | 'minimal';
  size?: 'sm' | 'md' | 'lg';
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = "Chargement...", 
  variant = 'default',
  size = 'md' 
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4',
    md: 'h-6 w-6',
    lg: 'h-8 w-8'
  };

  if (variant === 'minimal') {
    return (
      <div className="flex items-center justify-center p-4">
        <Loader2 className={`${sizeClasses[size]} animate-spin text-primary`} />
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <div className="relative">
          <Package className={`${sizeClasses[size]} animate-pulse text-primary`} />
          <div className="absolute inset-0 animate-spin">
            <div className="h-full w-full border-2 border-transparent border-t-primary rounded-full"></div>
          </div>
        </div>
        <div className="text-center">
          <span className="text-foreground font-medium">{message}</span>
        </div>
      </div>
    </div>
  );
};